import React, {useEffect, useRef, useState} from "react";
import './index.scss';
import Video from '../../../../assets/videos/tokenomics/Graph4.mp4';
import VideoMobile from '../../../../assets/videos/tokenomics/Graph4Mobile.mp4';
import {useInViewport} from "react-in-viewport";
import classNames from "classnames";
import useViewportSize from "../../../../hooks/useViewportSize";
import shapeImg from '../../../../assets/images/tokenomics/tokenomics2.svg'

const TokenSupply = () => {
    const [showComponent, setShowComponent] = useState(false);
    const componentRef = useRef();
    const [copyTO, setCopyTO] = useState();


    const { inViewport } = useInViewport(componentRef, { threshold: window.innerWidth > 800 ? 0.2 : 0.1 });

    useEffect(() => {
        if (!inViewport || (inViewport && showComponent)) return;
        setShowComponent(true);
    }, [inViewport]);

    const viewportSize = useViewportSize();

    const address = '0x580e2b3170AA36e7018eaD248298C8cc18B0f019';

    return(
        <div ref={componentRef} className={classNames('tokenSupply', showComponent && 'show')}>
            <div className='tokenSupply-tokenCount'>
                <div className='title'>
                    Dynamic <span style={{color: '#FF3BC8'}}>Worldbuilding</span>
                </div>
                <video style={{maxHeight: '445px'}} width="100%" height="100%" loop autoPlay playsInline muted>
                    <source src={window.innerWidth > 500 ? Video : VideoMobile} type="video/mp4"/>
                </video>
            </div>
            <div className='tokenSupply-infoToken'>
                <div className='tokenSupply-infoToken-price'>
                    <div className='buy'>
                        {/*<div className='title'>Buy Tax = <span style={{color: '#FF3BC8'}}>15%</span></div>*/}
                        <div className='text'>At <span className="tp">CLOUDBOX</span>, we go beyond static environments to create worlds that <span className="tp">feel alive</span>. From evolving landscapes to reactive NPCs, our games <span className="tp">adapt to player choices and actions</span>
                        </div>
                    </div>
                    <div className='sell'>
                        {/*<div className='title'>Sell Tax = <span style={{color: '#FF3BC8'}}>18%</span></div>*/}
                        <div className='text'>We don't just release games; <span className="tp">we co-create with our players</span>. Through interactive betas, community-driven feedback, and in-game tools for user-generated content, <span className="tp">we empower players</span> to leave their mark on the worlds we build</div>
                    </div>
                </div>
                {(false) && viewportSize.width > 760 ?
                <div className='tokenSupply-infoToken-contactAddress'>
                    <div className='title'>CONTRACT ADDRESS</div>
                    <div
                      className='address'
                      onClick={e => {
                          e.target.classList.add('copied');
                          navigator.clipboard.writeText(address);
                          clearTimeout(copyTO);

                          setCopyTO(setTimeout(() => {
                              e.target.classList.remove('copied');
                          }, 1000));
                      }}
                    >
                        {address}
                        <div className='copy' />
                    </div>
                </div>
                : <div className="tokenSupply-shapeBox">
                    <img src={shapeImg} alt="" className="tokenSupply-shape" />
                </div>
                }
            </div>
        </div>
    )
}

export default TokenSupply;
